import { render, staticRenderFns } from "./clip.vue?vue&type=template&id=118d9286&scoped=true&"
import script from "./clip.vue?vue&type=script&lang=js&"
export * from "./clip.vue?vue&type=script&lang=js&"
import style0 from "./clip.vue?vue&type=style&index=0&id=118d9286&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118d9286",
  null
  
)

export default component.exports